<template>
  <div v-if="getBranch()">
    <div class="w-100pct h-60px cl-white f-s-18px f-w-bold pd-5px dp-flex al-it-center jtf-ct-center" :style="`background-color: ${mainColor};`">
      <span class="mg-l-10px">{{ storeName }} | {{ branchName }}</span>
    </div>
    <div class="column is-6 is-offset-3 is-paddingless">
      <div class="columns is-centered is-marginless h-60px">
        <div class="column">
          <input placeholder="กรุณาใส่ชื่อสินค้าที่ต้องการค้นหา" class="input-data f-left pd-6px" v-model="search" type="search">
          <div class="f-left search pd-6px cs-pointer" :style="`background-color: ${mainColor};`" @click="searchData()">
            <svg-filler path="/static/svg/search.svg" :fill="'#ffffff'" width="20px" height="20px"/>
          </div>
        </div>
      </div>
      <div class="list-item">
        <div>
          <ListProduct :products.sync="products" :searchKey.sync="searchKey"/>
        </div>
      </div>
    </div>
    <div class="w-100pct h-60px cl-white f-s-18px f-w-bold" :style="`background-color: ${mainColor};`">
      <div class="columns is-marginless is-paddingless">
        <div class="column is-paddingless is-6 is-offset-3 dp-flex jtf-ct-space-between">
          <div class="pd-16px">
            <router-link :to="{ name: 'UserInfo' }" exact>
              <svg-filler path="/static/svg/user.svg" :fill="'#ffffff'" width="24px" height="24px"/>
            </router-link>
          </div>
          <div class="pd-6px">
            <router-link :to="{ name: 'ScanToSearch' }" exact>
              <svg-filler path="/static/svg/QR_icon.svg" :fill="'#ffffff'" width="48px" height="48px"/>
            </router-link>
          </div>
          <div class="pd-r-20px">
            <svg-filler path="/static/svg/basket.svg" :fill="'#ffffff'" width="24px" height="24px" class="mg-t-16px" v-if="amount === 0" />
            <router-link :to="{ name: 'Cart' }" exact v-else>
                <div class="tag cartItemCount is-danger pst-absolute mg-l-15px mg-t-8px">
                  {{ amount }}
                </div>
                <svg-filler path="/static/svg/basket.svg" :fill="'#ffffff'" width="24px" height="24px" class="mg-t-16px"/>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListProduct from './ListProduct'
import { mapActions, mapGetters } from 'vuex'
import { getBranchName } from '@/utils/helper/localStorage'
export default {
  name: 'home',
  components: {
    ListProduct
  },
  data () {
    return {
      page: 1,
      search: '',
      activeModal: false,
      branchName: ''
    }
  },
  methods: {
    ...mapActions([
      'setSearchKey',
      'loadProductMore',
      'setIsloading'
    ]),
    getBranch () {
      let getItem = window.localStorage.getItem('currentBranchPOS')
      const result = JSON.parse(getItem)
      return result
    },
    async searchData () {
      this.setIsloading(true)
      let hasProduct = await this.setSearchKey(this.search)
      this.setIsloading(false)
      if (!hasProduct) {
        this.$dialog.alert({
          title: 'เกิดข้อผิดพลาด',
          confirmText: 'ตกลง',
          message: '<center>ข้อมูลไม่ตรงกับสินค้าในระบบ</center>'
        })
      }
    },
    async scrollHanle (evt) {
      const scrollBottom = evt.target.scrollTop + evt.target.clientHeight
      const height = evt.target.scrollHeight
      if (evt.target.scrollTop !== 0 && scrollBottom === height) {
        if (this.productsNumber % 25 === 0) {
          this.setIsloading(true)
          await this.loadProductMore(++this.page)
          this.setIsloading(false)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      amount: 'getItemsAmount',
      searchKey: 'getSearchKey',
      products: 'getProduct',
      productsNumber: 'productsNumber',
      storeName: 'storeName',
      mainColor: 'mainColor'
    })
  },
  created () {
    this.search = this.searchKey
  },
  async mounted () {
    this.branchName = getBranchName()
  }
}
</script>
<style scoped>

.list-item {
  overflow: auto;
  height: calc(100vh - 180px);
}


.cartItemCount {
  border-radius: 50%;
  font-size: 12px;
}

.input-data {
  width: 80%;
  height: 36px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #fff;
  border: solid 1px #1b0000;
}
.search {
  width: 20%;
  height: 36px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue